/* ============================================================
   GFY Coupon Offers — behavior (vanilla JS, no dependencies)
   Loaded once with defer. Idempotent: safe if included twice.
   ============================================================ */
(function () {
  'use strict';
  if (window.__gfyInit) return;
  window.__gfyInit = true;

  var SS = window.sessionStorage;
  var cfg = {};
  try {
    var cfgEl = document.getElementById('gfy-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) { cfg = {}; }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Clipboard copy + confetti ---------------- */
  function confetti(x, y) {
    if (reduced) return;
    var colors = ['#C9A96E', '#B8964F', '#1A1A1A', '#FFFFFF', '#E7D9BC'];
    var root = document.createElement('div');
    root.className = 'gfy-confetti';
    root.style.left = x + 'px';
    root.style.top = y + 'px';
    for (var i = 0; i < 14; i++) {
      var p = document.createElement('i');
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', (Math.random() * 140 - 70) + 'px');
      p.style.setProperty('--dy', (40 + Math.random() * 80) + 'px');
      p.style.setProperty('--dr', (Math.random() * 540 - 270) + 'deg');
      root.appendChild(p);
    }
    document.body.appendChild(root);
    setTimeout(function () { root.remove(); }, 1100);
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;left:-9999px;top:0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    ta.remove();
  }

  function markCopied(btn) {
    var original = btn.dataset.gfyLabel || btn.textContent;
    btn.dataset.gfyLabel = original;
    btn.dataset.copied = 'true';
    btn.textContent = btn.dataset.gfyCopiedLabel || 'Copied!';
    btn.setAttribute('aria-live', 'polite');
    setTimeout(function () {
      btn.dataset.copied = 'false';
      btn.textContent = original;
    }, 2200);
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-gfy-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-gfy-copy');
    if (!code) return;
    var done = function () {
      markCopied(btn);
      try { SS.setItem('gfyCopied', code); } catch (e) {}
      var r = btn.getBoundingClientRect();
      confetti(r.left + r.width / 2, r.top);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
    } else { fallbackCopy(code); done(); }
  });

  /* Restore "remembered" copied code for this session */
  function restoreCopiedState(scope) {
    var code;
    try { code = SS.getItem('gfyCopied'); } catch (e) { return; }
    if (!code) return;
    (scope || document).querySelectorAll('[data-gfy-copy="' + code + '"]').forEach(function (b) {
      b.dataset.copied = 'true';
      b.textContent = b.dataset.gfyCopiedLabel || 'Copied!';
      setTimeout(function () { b.dataset.copied = 'false'; b.textContent = b.dataset.gfyLabel || 'Copy Code'; }, 2200);
    });
  }

  /* ---------------- Sticky bar rotation ---------------- */
  function initBar(bar) {
    var slides = bar.querySelectorAll('.gfy-bar__slide');
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }
    var idx = 0, speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000, timer = null, paused = false;
    slides[0].classList.add('is-active');
    if (reduced) return;
    function next() {
      if (paused) return;
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
    }
    function start() { stop(); timer = setInterval(next, speed); }
    function stop() { if (timer) clearInterval(timer); }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    start();
  }
  document.querySelectorAll('.gfy-bar[data-speed]').forEach(initBar);

  /* ---------------- Countdown timers ---------------- */
  document.querySelectorAll('[data-gfy-countdown]').forEach(function (el) {
    var end = new Date(el.getAttribute('data-gfy-countdown').replace(' ', 'T'));
    if (isNaN(end.getTime())) { el.hidden = true; return; }
    var d = el.querySelector('[data-d] b'), h = el.querySelector('[data-h] b'),
        m = el.querySelector('[data-m] b'), s = el.querySelector('[data-s] b');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.hidden = true; clearInterval(t); return; }
      var sec = Math.floor(diff / 1000);
      if (d) d.textContent = pad(Math.floor(sec / 86400));
      if (h) h.textContent = pad(Math.floor(sec / 3600) % 24);
      if (m) m.textContent = pad(Math.floor(sec / 60) % 60);
      if (s) s.textContent = pad(sec % 60);
    }
    var t = setInterval(tick, 1000); tick();
  });

  /* ---------------- Modal helper (FAB popup + exit popup) ---------------- */
  var lastFocus = null;
  function openModal(m) {
    if (!m) return;
    lastFocus = document.activeElement;
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var f = m.querySelector('.gfy-modal__close') || m;
    f.focus();
    restoreCopiedState(m);
  }
  function closeModal(m) {
    if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (ev) {
    var opener = ev.target.closest('[data-gfy-open]');
    if (opener) { openModal(document.getElementById(opener.getAttribute('data-gfy-open'))); return; }
    if (ev.target.closest('[data-gfy-close]') || ev.target.classList.contains('gfy-modal__overlay')) {
      closeModal(ev.target.closest('.gfy-modal'));
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    document.querySelectorAll('.gfy-modal:not([hidden])').forEach(closeModal);
  });

  /* ---------------- Exit-intent popup ---------------- */
  (function () {
    var modal = document.getElementById('gfy-exit-modal');
    if (!modal) return;
    var shown = false;
    try { shown = SS.getItem('gfyExitShown') === '1'; } catch (e) {}
    if (shown) return;
    var armed = false;
    var delay = (cfg.popupDelay || 5) * 1000;
    setTimeout(function () { armed = true; }, delay);
    function fire() {
      if (!armed || shown) return;
      var open = document.querySelector('.gfy-modal:not([hidden])');
      if (open) return;
      shown = true;
      try { SS.setItem('gfyExitShown', '1'); } catch (e) {}
      openModal(modal);
    }
    /* Desktop: cursor leaves viewport at the top */
    document.addEventListener('mouseout', function (ev) {
      if (!ev.relatedTarget && ev.clientY <= 0) fire();
    });
    /* Mobile: scrolled past 60% of the page */
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking || shown) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.6 && window.matchMedia('(max-width: 749px)').matches) fire();
      });
    }, { passive: true });
  })();

  /* ---------------- Mobile bottom bar spacing ---------------- */
  (function () {
    var bar = document.querySelector('.gfy-mobilebar');
    if (!bar) return;
    function apply() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      document.body.classList.toggle('gfy-has-mobilebar', mobile);
      document.documentElement.style.setProperty('--gfy-mobilebar-h', mobile ? bar.offsetHeight + 'px' : '0px');
    }
    apply();
    window.addEventListener('resize', apply, { passive: true });
  })();

  /* ---------------- Collection card badges ---------------- */
  (function () {
    if (!cfg.badgeEnabled || !cfg.pageCollection) return;
    var offers = (cfg.offers || []).filter(function (o) {
      return !o.collection || o.collection === cfg.pageCollection;
    });
    if (!offers.length) return;
    var tip = cfg.badgeTip || 'Use coupon for extra savings.';
    function decorate(scope) {
      (scope || document).querySelectorAll('.card-wrapper .card__inner').forEach(function (card) {
        if (card.querySelector('.gfy-badge')) return;
        var b = document.createElement('span');
        b.className = 'gfy-badge';
        b.textContent = cfg.badgeText || 'Offer Available';
        b.setAttribute('data-tip', tip);
        b.setAttribute('tabindex', '0');
        b.setAttribute('role', 'note');
        b.setAttribute('aria-label', (cfg.badgeText || 'Offer Available') + '. ' + tip);
        card.appendChild(b);
      });
    }
    var run = function () { decorate(document); };
    ('requestIdleCallback' in window) ? requestIdleCallback(run) : setTimeout(run, 200);
    /* Re-apply after AJAX facet/grid updates */
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { decorate(grid); }).observe(grid, { childList: true, subtree: true });
    }
  })();

  /* ---------------- Cart drawer: restore copied state when it re-renders ---------------- */
  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () { restoreCopiedState(drawer); }).observe(drawer, { childList: true, subtree: true });
  }

  restoreCopiedState(document);
})();
